import { HttpService } from '@Services/index';
import type { ApyDetails } from '@Types/apy';

export const fetchApyDetails = async () => {
  const { data } = await HttpService.get<ApyDetails>('v3/onboarding/apy');
  return data;
};
